import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Brand assets. Replace the files in /public/images with the final uploads
// (same filenames) and these references update automatically.
export const LOGOS = {
  wordmarkGreen: "/images/jero-one-logo.png",
  monogram: "/images/jero-one-logo.png",
};
